import Overview from './overview.vue';
import Full from './full.vue';
import MobFull from './mob-full.vue';
import MobOverview from './mob-overview.vue';

export const componentMap = {
	overview: Overview,
    full: Full,
    'mob-full': MobFull,
    'mob-overview': MobOverview
};